import { Injectable, inject } from '@angular/core';
import { ADMIN_ACTION_POLICIES } from '../../contracts/admin-action-policy';
import { AdminActionRunnerService } from '../admin-action-runner.service';
import { FunctionService } from '../function.service';

export interface TeamMemberClaimsInput {
  uid: string;
  enabled: boolean;
  role: string;
  description: string;
  reason: string;
  requireNotExists: boolean;
}

export interface TeamMemberClaimsResult {
  success?: boolean;
  auditId?: string;
  actionId?: string;
}

/** Owns team-member callable access, including lookup before adding a member. */
@Injectable({ providedIn: 'root' })
export class TeamActionsService {
  private readonly actionRunner = inject(AdminActionRunnerService);
  private readonly functionService = inject(FunctionService);

  lookupUser(query: string): Promise<{
    uid: string;
    email: string | null;
    displayName: string | null;
    profileName?: string | null;
    photoURL: string | null;
    phoneNumber: string | null;
    disabled: boolean;
  }> {
    return this.functionService.callFunction('adminLookupUser', { query });
  }

  setTeamMemberClaims(input: TeamMemberClaimsInput): Promise<TeamMemberClaimsResult> {
    const policy = ADMIN_ACTION_POLICIES.teamMemberClaims;
    return this.actionRunner.run(policy, input.uid, () =>
      this.functionService.callFunction(policy.backendCallable, input)
    );
  }
}
